import {
  type LookalikeFormSegment,
  type LookalikeSegmentDefinition,
  lookalikeSpecificCategory,
  type SimilarityLevelValue,
} from '../../../../../../../../../../modules/audiences/AudienceForm/types';

type LookalikeSelectionConfig = {
  similarityLevel: SimilarityLevelValue;
  includeSeedSegment: boolean;
};

export const createSegmentsFromLookalikeDefinition = (
  definition: LookalikeSegmentDefinition,
  config: LookalikeSelectionConfig
): LookalikeFormSegment[] => {
  const segments: LookalikeFormSegment[] = [];

  const selectedSimilarityData = definition.lookalike_segment_similarities.find(
    sim => sim.similarity_level === config.similarityLevel
  );

  if (selectedSimilarityData) {
    const similaritySegment: LookalikeFormSegment = {
      ...selectedSimilarityData.segment,
      sub_category: lookalikeSpecificCategory.Similarity,
      account_id: definition.account_id,
      propensity: selectedSimilarityData.similarity_level,
      lookalike_definition_id: definition.id,
    };

    segments.push(similaritySegment);
  }

  if (config.includeSeedSegment && definition.lookalike_segment_seed_aggregate) {
    const seedSegmentData = definition.lookalike_segment_seed_aggregate.segment;
    const seedSegment: LookalikeFormSegment = {
      ...seedSegmentData,
      sub_category: lookalikeSpecificCategory.SeedAggregate,
      account_id: definition.account_id,
      lookalike_definition_id: definition.id,
    };

    segments.push(seedSegment);
  }

  return segments;
};
